<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-about-author element-with-heading" id="about-the-author">
<div class="heading heading-with-title heading-without-image" id="about-the-author-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Want More City Owl Press Books?</h1>
</div>
</div>
</div>
</div>
<div class="text" id="about-the-author-text">
<p class="first first-in-chapter first-full-width"><a class="content-external-link" href="http://smarturl.it/CONewsletter" target="_blank">Click here</a> to sign up for the City Owl Press newsletter and be the first to find out about special offers, including FREE book days, contents, giveaways, cover reveals, and more!</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Sign up now and become a City Owl Reader today! And join our City Owl Reader-Author group <a class="content-external-link" href="http://smarturl.it/COReadersGroup" target="_blank">here</a> for even more deals and a whole lot of community and fun!</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wantmorecityowlpressbooks.vue?03450edd